export function formatDateToYYYYMMDD(date: Date | null) {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatDateToShort(isoString?: string | null) {
  if (!isoString) return null;
  // Handle ISO 8601 format with time (e.g., 2026-02-04T14:27:28.000000Z)
  const date = isoString.includes('T') ? new Date(isoString) : parseDateAsLocal(isoString);
  if (!date || isNaN(date.getTime())) return null;

  return new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric', day: 'numeric' }).format(date);
}

export function formatDateToMMDDYYYY(isoString?: string | null) {
  if (!isoString) return null;
  // Handle ISO 8601 format with time (e.g., 2026-02-04T14:27:28.000000Z)
  const date = isoString.includes('T') ? new Date(isoString) : parseDateAsLocal(isoString);
  if (!date || isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}/${day}/${year}`;
}

export const parseDateAsLocal = (date: string) => {
  return new Date(date + 'T00:00:00');
};

export const formatMMDDYYYYToYYYYMMDD = (dateString: string | null | undefined) => {
  if (!dateString) return null;
  const mmddyyyyMatch = dateString.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (mmddyyyyMatch) {
    const [, month, day, year] = mmddyyyyMatch;
    return `${year}-${month}-${day}`;
  }
  const date = parseDateAsLocal(dateString);
  if (isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatYYYYMMDDToMMDDYYYY = (dateString: string | null | undefined) => {
  if (!dateString) return null;
  const yyyymmddMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (yyyymmddMatch) {
    const [, year, month, day] = yyyymmddMatch;
    return `${month}/${day}/${year}`;
  }
  const date = parseDateAsLocal(dateString);
  if (isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}/${day}/${year}`;
};

